/**
 * aiConverters.js
 *
 * DashboardAiManagementPageから抽出された純粋関数群
 * AI管理固有のデータ変換ロジックを提供
 */

/**
 * APIレスポンスをテーブル行にフラット化（AI管理用）
 * @param {Object} row - APIレスポンス行
 * @returns {Object} フラット化された行データ
 */
export function flattenRow(row) {
  return {
    id: row.id,
    deadlineCheck: row.deadlineCheck || '',
    task: row.task || '',
    oemRegion: row.oemRegion || '',
    status_name: row.status || '',
    actors_display: (row.actors || []).map((a) => a.name).join(', '),
    assignees_display: (row.assignees || []).map((a) => a.user_name).join(', '),
    deadline: row.deadline || '',
    memo: row.memo || '',
    createdBy: row.createdBy || '',
    createdAt: row.createdAt || '',
    updatedBy: row.updatedBy || '',
    updatedAt: row.updatedAt || '',
    updated_at_iso: row.updated_at_iso || null,
  };
}

/**
 * 複数キーに対して、行データから一意な値を抽出してセレクトボックス用のオプションを生成（AI管理用）
 * @param {Array} rows - データ行の配列
 * @param {Array} keys - 抽出対象のキー名配列
 * @returns {Object} キーごとのオプション配列 { key: ['', value1, value2, ...] }
 */
export function buildSelectOptions(rows, keys) {
  const optionsByKey = Object.fromEntries(keys.map((key) => [key, new Set()]));
  rows.forEach((row) => {
    keys.forEach((key) => {
      const value = row[key];
      if (value !== undefined && value !== null && value !== '') {
        optionsByKey[key].add(value);
      }
    });
  });
  return Object.fromEntries(
    Object.entries(optionsByKey).map(([key, values]) => [key, ['', ...Array.from(values)]]),
  );
}
